import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  key: 0,
  class: "col-auto d-desktop-inline-block align-self-center"
}
const _hoisted_4 = ["innerHTML", "title"]
const _hoisted_5 = ["innerHTML", "title"]
const _hoisted_6 = { class: "col-auto d-desktop-inline-block" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col" }
const _hoisted_9 = {
  class: "nav-link nav-link__other",
  href: "https://service.stadtwerke-bochum.de/online/welcome",
  title: "Zum Kundencenter",
  target: "_blank"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, " Kundencenter ", -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, " Suche ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, " Warenkorb ", -1)
const _hoisted_14 = { class: "col-auto d-desktop-inline-block" }
const _hoisted_15 = {
  href: "https://www.stadtwerke-bochum.de/",
  target: "_blank",
  class: "brand-company-link"
}
const _hoisted_16 = ["src"]

import {
  reactive,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  computed,
  nextTick,
  ref,
  watch,
} from 'vue';
import { useStore } from 'vuex';
import { env } from '@/helpers';
import PartnerInterface from '@/interfaces/PartnerInterface';
import IoSearchForm from '@/components/IoSearchForm.vue';
import IoSidebar from '@/components/IoSidebar.vue';
import MenuInterface from '@/interfaces/MenuInterface';
import HeaderMain from '@/components/BaseHeader/BaseHeaderMain.vue';
import CartWidget from '@/components/CartWidget.vue';
import HeaderTop from '@/components/BaseHeader/BaseHeaderTop.vue';
import IconCart from '@/components/IconCart.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUser, faSearch, faBars } from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

library.add(faUser);
library.add(faSearch);
library.add(faBars);

const store = useStore();
const logoSrc = window.ioappConfig.logo;
const companyLogoSrc = window.ioappConfig.companyLogo;
const partner = computed<PartnerInterface>(() => store.getters['partner/current']);
const partnerActive = computed(() => store.getters['partner/active']);
const logoBar = ref();
const navBar = ref();
const isMobile = ref(false);
const isDesktop = computed(() => !isMobile.value);

const header = reactive({
  top: 0,
  $el: null as null | HTMLElement,
});

const currentPage = computed(() => store.getters['page/page']);

const activeMenuItems = (menuItems: MenuInterface[]) => {
  let aMenuItems: MenuInterface[] = [];
  let hasActive = false;

  if (Array.isArray(menuItems) && menuItems.length) {
    aMenuItems = menuItems.map((menuItem) => {
      const nMenuItem = menuItem;
      nMenuItem.active = currentPage.value.url === nMenuItem.url;
      if (menuItem.children) {
        const menuItemChildren = activeMenuItems(nMenuItem.children || []);
        nMenuItem.children = menuItemChildren.items;

        nMenuItem.active = nMenuItem.active || menuItemChildren.active;
      }

      hasActive = hasActive || nMenuItem.active;

      return nMenuItem;
    });
  }

  return {
    items: aMenuItems,
    active: hasActive,
  };
};

const menu = computed(() => {
  const $pageVal = currentPage.value;

  return $pageVal
    ? activeMenuItems(store.getters['menus/menu']('header')).items
    : store.getters['menus/menu']('header');
});

const getDepth = (menuItems: MenuInterface[]): number => {
  const depth = (menuItems && menuItems.length) ? 1 : 0;
  let menuItemsMaxDepth = 0;

  (menuItems || []).forEach((menuItem) => {
    const menuItemMaxDepth = Array.isArray(menuItem.children)
      ? 1 + Math.max(...menuItem.children.map((mItem) => getDepth(mItem.children || [])))
      : 0;

    if (menuItemMaxDepth > menuItemsMaxDepth) {
      menuItemsMaxDepth = menuItemMaxDepth;
    }
  });

  return depth + menuItemsMaxDepth;
};

const menuDepth = computed(() => getDepth(menu.value || []));
const menuItemsTop = computed(() => {
  let $menuItemsTop: MenuInterface[] = [];

  if (menuDepth.value >= 3) {
    $menuItemsTop = [...menu.value].map((menuItem) => {
      const nMenuItem = { ...menuItem };

      delete nMenuItem.children;

      return nMenuItem;
    });
  }

  return $menuItemsTop;
});

const menuItemsMain = computed(() => {
  let $menuItemsMain: MenuInterface[];
  let $menuItemsMainFiltered: MenuInterface[];

  if (menuDepth.value >= 3) {
    $menuItemsMain = [...(menu.value || [])];
    $menuItemsMainFiltered = [...$menuItemsMain].filter((menuItem) => menuItem.active);

    if ($menuItemsMainFiltered.length) {
      $menuItemsMain = $menuItemsMainFiltered[0].children || [];
    } else if ($menuItemsMain.length) {
      $menuItemsMain = $menuItemsMain[0].children || [];
    }
  } else {
    $menuItemsMain = [...(menu.value || [])];
  }

  return $menuItemsMain || [];
});

const setHeaderPos = () => {
  header.top = 0;

  nextTick(() => {
    const $wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement;
    const $body = document.querySelector('body');
    let top = 0;

    if ($wpAdminBar) {
      top += $wpAdminBar.offsetHeight;
    }

    header.top = top;

    if ($body && header.$el) {
      $body.style.paddingTop = `${header.$el.offsetHeight}px`;
    }
  });
};
const minAmountToScroll = ref(0);
const scrollTop = ref(0);
const hideHeader = ref(false);

const setHeaderTop = () => {
  minAmountToScroll.value = 0;
  if (header.$el) {
    minAmountToScroll.value += header.$el.offsetHeight;
  }

  const $wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement;
  if ($wpAdminBar) {
    minAmountToScroll.value += $wpAdminBar.offsetHeight;
  }

  if (window.scrollY > minAmountToScroll.value && window.scrollY > scrollTop.value) {
    hideHeader.value = true;
    store.dispatch('search/close');
    store.dispatch('sidebar/close');
  } else {
    hideHeader.value = false;
  }

  scrollTop.value = window.scrollY;
};

const checkIfMobile = () => {
  if (navBar.value && logoBar.value) {
    isMobile.value = false;

    nextTick(() => {
      navBar.value.style.position = 'absolute';
      logoBar.value.style.position = 'absolute';
      const parentStyle = window.getComputedStyle(navBar.value.parentElement);
      const maxWidth = navBar.value.parentElement.offsetWidth
          - parseFloat(parentStyle.paddingLeft)
          - parseFloat(parentStyle.paddingRight);
      const navBarWidth = navBar.value.offsetWidth;
      const logoBarWidth = logoBar.value.offsetWidth;

      if ((navBarWidth + logoBarWidth) > maxWidth) {
        isMobile.value = true;
      }

      navBar.value.style.position = '';
      logoBar.value.style.position = '';
    });
  }
};

onBeforeMount(() => {
  store.dispatch('menus/fetchBySlug', 'header');
});

onMounted(() => {
  header.$el = document.querySelector('header');
  window.addEventListener('resize', setHeaderPos);
  window.addEventListener('load', setHeaderPos);
  window.addEventListener('scroll', setHeaderTop);
  window.addEventListener('resize', checkIfMobile);
  window.addEventListener('load', checkIfMobile);
  setHeaderPos();
  setHeaderTop();
  checkIfMobile();
  for (let i = 100; i < 1000; i += 100) {
    setTimeout(setHeaderPos, i);
    setTimeout(setHeaderTop, i);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setHeaderPos);
  window.removeEventListener('load', setHeaderPos);
  window.addEventListener('scroll', setHeaderTop);
  window.removeEventListener('resize', checkIfMobile);
  window.removeEventListener('load', checkIfMobile);
});

const cartEnabled = env('CART_ENABLED', false);

const toggleSidebar = () => {
  store.dispatch('sidebar/toggle', 'sidebar');
};

const toggleSearch = () => {
  store.dispatch('search/toggle');
};

watch(() => isMobile.value, () => {
  store.dispatch('sidebar/close');
});

return (_ctx: any,_cache: any) => {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      style: _normalizeStyle(`top:${_unref(header).top}px`),
      class: _normalizeClass(["d-print-none", {
        'slide-up': hideHeader.value,
        'desktop': _unref(isDesktop),
        'mobil': isMobile.value,
      }])
    }, [
      (_unref(menuItemsTop).length)
        ? (_openBlock(), _createBlock(HeaderTop, {
            key: 0,
            items: _unref(menuItemsTop)
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      _createElementVNode("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            ref: (_value, _refs) => {
              _refs['logoBar'] = _value
              logoBar.value = _value
            },
            class: _normalizeClass(["row brand-row g-0 d-desktop-block", { 'justify-content-end': _unref(isDesktop) }])
          }, [
            (_unref(partner) && _unref(partnerActive))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_unref(partner).url)
                    ? (_openBlock(), _createBlock(_component_IoRouterLink, {
                        key: 0,
                        "link-url": _unref(partner).url,
                        "link-target": "_blank",
                        class: "brand-image-link partner"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: _unref(partner).thumbnail,
                            title: _unref(partner).title
                          }, null, 8, _hoisted_4)
                        ]),
                        _: 1
                      }, 8, ["link-url"]))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        innerHTML: _unref(partner).thumbnail,
                        title: _unref(partner).title
                      }, null, 8, _hoisted_5))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_IoRouterLink, {
                "link-url": "/",
                class: "brand-image-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _unref(logoSrc),
                    alt: "",
                    loading: "lazy"
                  }, null, 8, _hoisted_7)
                ]),
                _: 1
              })
            ])
          ], 2),
          _createElementVNode("div", {
            ref: (_value, _refs) => {
              _refs['navBar'] = _value
              navBar.value = _value
            },
            class: "d-flex navbar-nav align-items-center text-center col"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(HeaderMain, { items: _unref(menuItemsMain) }, null, 8, ["items"])
            ]),
            _createElementVNode("a", _hoisted_9, [
              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-user" }),
              _hoisted_10
            ]),
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link nav-link__other", { 'last': _unref(isDesktop) && !_unref(cartEnabled) }]),
              title: "Suche öffnen",
              href: "/suche/",
              onClick: _withModifiers(toggleSearch, ["prevent"])
            }, [
              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-search" }),
              _hoisted_12
            ], 10, _hoisted_11),
            (_unref(cartEnabled))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass(["nav-link nav-link__other", { 'last': _unref(isDesktop) && _unref(cartEnabled) }]),
                  href: "/warenkorb/",
                  title: "Warenkorb öffnen",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleCart && _ctx.toggleCart(...args)), ["prevent"]))
                }, [
                  _createVNode(IconCart),
                  _hoisted_13
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link nav-link__other sidebar-toggle", { 'last': isMobile.value }]),
              onClick: toggleSidebar
            }, [
              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-bars" })
            ], 2),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("a", _hoisted_15, [
                _createElementVNode("img", {
                  src: _unref(companyLogoSrc),
                  alt: "Logo der Stadtwerke Bochum",
                  loading: "lazy"
                }, null, 8, _hoisted_16)
              ])
            ])
          ], 512)
        ])
      ])
    ], 6),
    _createVNode(IoSearchForm),
    _createVNode(IoSidebar, {
      items: _unref(menu) || []
    }, null, 8, ["items"]),
    _createVNode(CartWidget)
  ], 64))
}
}

})